import React from 'react';
import RevealOnScroll from './RevealOnScroll';
import machine_2 from '../assets/images/machine-2.jpeg';

const About = () => (
    <section id="about" className="about-section">
        <div className="container about-container">
            <RevealOnScroll>
                <div className="about-image">
                    <img src={machine_2} alt="Mining Operation" />
                </div>
            </RevealOnScroll>
            <RevealOnScroll>
                <div className="about-text">
                    <h3>Forged from the Earth, Built for a Lifetime</h3>
                    <p>Founded on a commitment to excellence, Tiwari Minerals Company has been a leading supplier of high-grade stone products for over three decades.</p>
                </div>
            </RevealOnScroll>
        </div>
    </section>
);

export default About;